import React from 'react';

import './custom-button.styles.scss'

const CustomButton = ({ className, children, ...otherProps }) => (
  <button className={`custom-button disable-highlight ${className}`} {...otherProps}>
    {children}
  </button>
)

export default CustomButton;
